import { InternalDatalistTablePropsType } from "types/datalist-types";
import { isVisible } from "utilities/datalist/datalist-utilities";
import DatalistTableHeaderItem from "./DatalistTableHeaderItem";

const DatalistTableHeader = <TItemType, TFilterType, TSortType>(props: InternalDatalistTablePropsType<TItemType, TFilterType, TSortType>) => {

    return (
        <thead className="datalist">
            <tr>
                {props.columns.filter(c => isVisible(c)).map(c => {
                    return <th className={`app-label ${c.className || ''}`} key={`datalist-${props.name}-table-header-${c.name}}`}>
                        <DatalistTableHeaderItem column={c} />
                    </th>;
                })}
            </tr>
        </thead>
    );
}

export default DatalistTableHeader;
